"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bottomInfo = exports.description = exports.name = exports.contentType = exports.topInfo = exports.contentInfo = exports.contentImage = exports.root = void 0;

var _emotion = require("emotion");

var root = function root(theme) {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("padding:20px;min-height:320px;box-sizing:border-box;border-radius:3px;background-color:", theme.color.dark.saturn, ";display:flex;flex-direction:column;width:284px;")
  );
};

exports.root = root;
var contentImage =
/*#__PURE__*/
(0, _emotion.css)("margin-bottom:16px;flex-shrink:0;");
exports.contentImage = contentImage;
var contentInfo =
/*#__PURE__*/
(0, _emotion.css)("display:flex;flex-direction:column;flex-grow:1;");
exports.contentInfo = contentInfo;
var topInfo =
/*#__PURE__*/
(0, _emotion.css)("display:flex;flex-shrink:0;align-items:center;");
exports.topInfo = topInfo;

var contentType = function contentType(theme) {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("font-size:10px;font-weight:500;letter-spacing:2px;color:", theme.color.dark.iron, ";text-transform:uppercase;")
  );
};

exports.contentType = contentType;

var name = function name(theme) {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("font-size:16px;line-height:1.5;color:", theme.color.dark.copper, ";margin-top:8px;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;text-overflow:ellipsis;overflow:hidden;")
  );
};

exports.name = name;

var description = function description(theme) {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("font-size:12px;line-height:1.83;color:", theme.color.dark.iron, ";margin-top:8px;margin-bottom:8px;")
  );
};

exports.description = description;
var bottomInfo =
/*#__PURE__*/
(0, _emotion.css)("display:flex;flex-shrink:0;align-items:flex-end;line-height:1;");
exports.bottomInfo = bottomInfo;